<template>
	<div class="device-setting-bind">
		<div class="alert_bg2" v-if="$store.state.bind_list.length <= 0"></div>
		<Message myWidth="360px" myHeight="308px" v-if="!isShowInstallGuide">
			<template v-slot:content>
				<div class="bind-wrap">
					<div
						class="close-btn"
						@click="hideBindClick()"
						v-if="
							$store.state.bind_list &&
							$store.state.bind_list.length > 0
						"
					></div>
					<div class="title">
						{{
							$store.state.bind_list &&
							$store.state.bind_list.length > 0
								? "添加主机设备"
								: "未绑定主机设备"
						}}
					</div>
					<div class="text1">绑定码绑定：</div>
					<div class="input-wrap">
						<div class="input-tips" v-if="!activecode">
							输入绑定码绑定设备
						</div>
						<input
							type="number"
							v-model="activecode"
							v-on:input="inputFun()"
						/>
						<div class="bind-btn" @click="bindDeviceClick()">
							绑定
						</div>
					</div>
					<div class="line"></div>
					<div class="tip-wrap">
						<div class="tip1">快速绑定</div>
						<div class="tip2">
							通过设备的套件中心或插件中心打开节点小宝
						</div>
						<div
							class="support-text"
							@click="isShowInstallGuideClick()"
						>
							安装指南
						</div>
					</div>
				</div>
			</template>
		</Message>
		<Message v-if="isShowInstallGuide" myWidth="490px" myHeight="450px">
			<template v-slot:content>
				<div class="tips-body">
					<div
						class="close-btn"
						@click="isShowInstallGuideClick()"
					></div>
					<div class="tips-title">节点小宝2.0操作指南</div>
					<div class="tips-item-title">
						<span class="icon"></span><span>如何绑定Nas设备？</span>
					</div>
					<div class="tips-item-desc">
						<span class="icon"></span
						><span
							>前往NAS套件中心下载节点小宝2.0套件；群晖套件：点击对应的平台下载插件。</span
						>
					</div>
					<div class="tips-downloads">
						<div
							class="tips-download"
							@click="jumpDownload($store.state.app_url.qh_x86)"
						>
							DSM6_x86
						</div>
						<div
							class="tips-download"
							@click="jumpDownload($store.state.app_url.qh_arm)"
						>
							DSM6_arm
						</div>
						<div
							class="tips-download"
							@click="
								jumpDownload($store.state.app_url.qh_dsm7_x86)
							"
						>
							DSM7_x86
						</div>
						<div
							class="tips-download"
							@click="
								jumpDownload($store.state.app_url.qh_dsm7_arm)
							"
						>
							DSM7_arm
						</div>
					</div>
					<div class="tips-item-desc">
						<span class="icon"></span
						><span
							>安装并打开节点小宝2.0套件后使用微信扫一扫登录节点小宝2.0，登录即绑定。</span
						>
					</div>
					<div class="tips-item-title">
						<span class="icon"></span
						><span>绑定后怎么使用节点小宝？</span>
					</div>
					<div class="tips-item-desc">
						<span class="icon"></span
						><span
							>PC端：https://yc.ionewu.com/jdxb/
							打开网页后，使用微信扫一扫即可登录，若已绑定手机，可使用手机及短信验证码登录，登录后可远程管理设备；</span
						>
					</div>
					<div class="tips-item-desc">
						<span class="icon"></span
						><span>手机端：即将上线。</span>
					</div>

					<div class="tips-item-title">
						<span class="icon"></span><span>如何修改缓存路径?</span>
					</div>

					<div class="tips-item-desc">
						<span class="icon"></span>
						<span
							>控制面板→共享文件夹→选中“OWSpeedup”→点击编辑→常规→所在位置→选择用于缓存的磁盘。</span
						>
					</div>
					<div
						class="tips-sure-btn"
						@click="isShowInstallGuideClick()"
					>
						确 定
					</div>
				</div>
			</template>
		</Message>
	</div>
</template>

<script>
import Message from "./Message.vue";
import { mapActions } from "vuex";

export default {
	components: {
		Message,
	},
	props: [],
	data: function () {
		return {
			device_icon3: require("../assets/home/node/device_setting3.svg"),
			myWidth: "369px",
			myHeight: "395px",
			activecode: "",
			isShowInstallGuide: false,
		};
	},
	methods: {
		...mapActions([""]),
		isShowInstallGuideClick: function () {
			let _that = this;
			_that.isShowInstallGuide = !_that.isShowInstallGuide;
		},
		jumpDownload: function (url) {
			let _that = this;
			_that.$common.bridge(_that.$store.state.client).openBrowser(url);
		},
		inputFun: function () {
			let _that = this;
			if (_that.activecode.length > 6) {
				_that.activecode = _that.activecode.slice(0, 6);
			}
		},
		hideBindClick: function () {
			let _that = this;
			_that.$emit("showOrHideBindClick", false);
		},
		bindDeviceClick: function () {
			let _that = this;
			if (_that.activecode.length != 6) {
				return;
			} else {
				_that.$emit("bindDeviceClick", _that.activecode);
				_that.$emit("showOrHideBindClick", false);
			}
		},
	},
	mounted() {
		let _that = this;
	},
};
</script>

<style scoped lang="less">
.alert_bg2 {
	width: 940px;
	height: 525px;
	background-image: url(../assets/userinfo/agree_bg.jpg);
	background-size: 100% 100%;
	position: absolute;
	top: 15px;
	left: 10px;
	border-radius: 6px;
}
.device-setting-bind {
	position: absolute;
	top: 50px;
	left: 10px;
	width: 960px;
	height: 560px;
	padding-top: 1px;
	.mixinBg {
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.close-btn {
		background-image: url(../assets/mall/exchange_alert_close.png);
		background-size: 100% 100%;
		width: 15px;
		height: 15px;
		position: absolute;
		right: 15px;
		top: 15px;
		cursor: pointer;
	}
	.close-btn:hover {
		opacity: 0.8;
	}
	.title {
		text-align: center;
		font-weight: 700;
		font-size: 17px;
		height: 50px;
		line-height: 50px;
		color: #1a1a1a;
		border-bottom: 1px solid #e6e6e6;
	}

	.bind-wrap {
		padding-top: 1px;

		.text1 {
			margin: 0 auto;
			margin-top: 20px;
			font-size: 14px;
			color: #1a1a1a;
			font-weight: normal;
			width: 300px;
		}
		.input-wrap {
			position: relative;
			margin: 0 auto;
			margin-top: 14px;
			width: 300px;
			height: 50px;
			box-sizing: border-box;
			// border: 1px solid #1f5de3;
			border-radius: 102px;
			overflow: hidden;
			background-color: #f5f5f5;

			.input-tips {
				position: absolute;
				top: 0;
				left: 40px;
				height: 50px;
				line-height: 50px;
				font-size: 14px;
				color: #666666;
				z-index: 0;
			}

			input {
				padding-right: 94px;
				width: 100%;
				height: 100%;
				background-color: transparent;
				font-size: 20px;
				font-weight: 700;
				color: #666666;
				text-align: center;
				box-sizing: border-box;
				letter-spacing: 2px;
				position: absolute;
				left: 0;
				top: 0;
				text-align: center;
			}
			input::-webkit-outer-spin-button,
			input::-webkit-inner-spin-button {
				-webkit-appearance: none;
			}
			.bind-btn {
				position: absolute;
				right: 0;
				top: 0;
				background-color: #1f5de3;
				width: 94px;
				height: 50px;
				line-height: 50px;
				text-align: center;
				color: #ffffff;
				font-weight: 700;
				font-size: 14px;
			}
			.bind-btn:hover {
				cursor: pointer;
				opacity: 0.9;
			}
		}
	}

	.tip-wrap {
		margin: 0 auto;
		margin-top: 45px;
		position: relative;
		width: 300px;
		padding-top: 15px;
		background-color: #f5f5f5;
		.tip1 {
			margin-left: 50px;
			font-size: 14px;
			color: #1a1a1a;
		}
		.tip2 {
			margin-left: 50px;
			margin-top: 3px;
			font-size: 12px;
			color: #666666;
		}
	}
	.tip-wrap::before {
		content: "";
		position: absolute;
		top: 18px;
		left: 12px;
		width: 32px;
		height: 32px;

		background-image: url("../assets/home/node/device11.svg");
		.mixinBg();
	}
	.support-text {
		position: relative;
		margin-top: 10px;
		margin-left: 50px;
		padding-bottom: 10px;
		font-size: 12px;
		color: #1f5de3;
		text-align: left;
		padding-left: 20px;
	}
	.support-text::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 17px;
		height: 17px;
		background-image: url("../assets/home/node/device12.svg");
		.mixinBg();
	}
	.support-text::after {
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		width: 80px;
		height: 17px;
		cursor: pointer;
		background-color: transparent;
	}
	.support-text:hover {
		cursor: pointer;
		text-decoration: underline;
	}

	.tips-body::-webkit-scrollbar {
		display: none;
	}
	.tips-body {
		-ms-overflow-style: none;
		scrollbar-width: none;
		text-align: center;
		margin-top: -225px;
		margin-left: -245px;
		width: 490px;
		height: 450px;
		background-color: #f5f5f5;
		border-radius: 5px;
		padding-top: 1px;
		position: absolute;
		left: 50%;
		top: 50%;
		overflow-y: scroll;

		.close-btn {
			width: 20px;
			height: 20px;
			background-image: url(../assets/home/node/close.png);
			background-size: 100% 100%;
			position: absolute;
			right: 10px;
			top: 10px;
		}

		.close-btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}

		.tips-title {
			color: #1a1a1a;
			font-size: 20px;
			font-weight: bolder;
			margin-top: 35px;
		}
		.tips-downloads {
			margin-top: 10px;
			.tips-download {
				padding: 2px 5px;
				background-color: #e8ecf4;
				border: 1px solid #1f5de3;
				display: inline-block;
				color: #666666;
				font-size: 12px;
				border-radius: 4px;
				margin: 0 5px;
			}
			.tips-download:hover {
				cursor: pointer;
				opacity: 0.8;
			}
		}
		.tips-item-title {
			text-align: left;
			color: #666666;
			font-size: 14px;
			font-weight: bolder;
			margin-left: 40px;
			margin-top: 20px;
			span {
				display: inline-block;
				vertical-align: middle;
			}
			.icon {
				width: 10px;
				height: 10px;
				background: #1f5de3;
				border-radius: 102px 102px 102px 102px;
				opacity: 1;

				margin-right: 5px;
			}
		}
		.tips-item-desc {
			text-align: left;
			color: #666666;
			font-size: 12px;
			margin-left: 55px;
			margin-top: 14px;
			span {
				vertical-align: top;
				display: inline-block;
				width: 380px;
			}
			.icon {
				width: 5px;
				height: 5px;
				border: 1px solid #1f5de3;
				border-radius: 102px 102px 102px 102px;
				opacity: 1;
				margin-right: 5px;
				margin-top: 5px;
			}
		}
		.tips-sure-btn {
			margin: 35px auto 20px auto;
			background-color: #215fe4;
			border-radius: 20px;
			width: 140px;
			height: 40px;
			line-height: 40px;
			color: #ffffff;
			font-size: 16px;
		}
		.tips-sure-btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}
	}
}
</style>
